import numeral from 'numeral';

export const fData = (number: string | number) => numeral(number).format('0.0 b');

// TODO: Adjust currency
export const fCurrency = (number: number, currency: string) =>
    new Intl.NumberFormat('lt-LT', { currency, style: 'currency', maximumFractionDigits: 2 }).format(number);

export const fAmountInCentsToAmountString = (amountInCents: number): string => {
    return (amountInCents / 100).toFixed(2).replace('.', ',');
};
